import React from 'react'
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material'
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import TimelineIcon from "@mui/icons-material/Timeline";
import VaccinesIcon from '@mui/icons-material/Vaccines';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';

const StatewiseStats = ({ selectedState }) => {
    const statCards = [
        {
            title: "Total TCCC",
            value: selectedState?.tccc_facilities,
            icon: <ApartmentIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
        {
            title: "Total DCCC",
            value: selectedState?.dccc_facilities,
            icon: <BusinessIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
        {
            title: "Total Registered Beneficiaries",
            value: selectedState?.total_patients,
            icon: <GroupsIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
        {
            title: "No. of Beneficiaries Under Treatment at DCCC",
            value: selectedState?.total_dccc,
            icon: <VaccinesIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
        {
            title: "No. of Pending Referrals at TCCC",
            value: selectedState?.total_mi,
            icon: <TransferWithinAStationIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
        {
            title: "Total Completed Chemo Sessions",
            value: selectedState?.total_chemo,
            icon: <TimelineIcon sx={{ color: "#6C7FF9", fontSize: 20 }} />,
        },
    ];

    return (
        <Card sx={{ borderRadius: "20px", boxShadow: 1, height: "37.5em", overflowY: "auto" }}>
            <CardContent>
                <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={2}
                    sx={{ minHeight: 64 }}
                >
                    {selectedState?.state_name} - State-wise Statistics
                </Typography>

                <Box display="grid" gap={2}>
                    {statCards.map((card, index) => (
                        <Card key={index} variant="outlined" sx={{ borderRadius: 3, p: 2 }}>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                            >
                                <Typography variant="body2" color="gray" sx={{ marginRight: "15px" }}>
                                    {card.title}
                                </Typography>
                                <Avatar
                                    sx={{ bgcolor: "#E0E7FF", width: 34, height: 34 }}
                                >
                                    {card.icon}
                                </Avatar>
                            </Box>
                            <Typography variant="h6" fontWeight={700} mt={1}>
                                {card.value || "0"}
                            </Typography>
                        </Card>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export default StatewiseStats